// @flow

import React, { Component } from 'react';
import { Card, Button, Header } from 'semantic-ui-react';
import ResourceImage from './ResourceImage';
import ResourceSelector from './ResourceSelector/index';

type Props = {
  name: string,
  title: string,
  value?: string,
  thumbnail?: string,
  resourceType: ResourceCategory,
};

type State = {
  selectorOpen: boolean,
  value?: string,
  resource?: BucketResource,
};

const mapPropsToResource = props => ({
  type: {
    category: props.resourceType,
  },
  url: {
    web: props.thumbnail,
  },
});

class InputResourceCard extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectorOpen: false,
      value: props.value,
      resource: mapPropsToResource(props),
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        value: nextProps.value,
        resource: mapPropsToResource(nextProps),
      });
    }
  }

  onShowSelector = (event: SyntheticEvent) => {
    event.preventDefault();
    this.setState({ selectorOpen: true });
  };

  onHideSelector = () => this.setState({ selectorOpen: false });

  onResourceSelected = (resource: BucketResource) => {
    // Updating current image
    this.setState({
      selectorOpen: false,
      resource,
      value: resource.id,
    });
  };

  onRemoveResource = (event: SyntheticEvent) => {
    event.preventDefault();

    this.setState({
      resource: undefined,
      value: undefined,
    });
  };

  render() {
    const { name, title, resourceType } = this.props;
    const { selectorOpen, value, resource } = this.state;

    return (
      <div>
        <Header as="h3" textAlign="center">{title}</Header>
        <Card centered>
          <input type="hidden" name={`${name}_id`} defaultValue={value || ''} />
          <ResourceImage resource={resource} />
          <Card.Content>
            <div className="ui two buttons">
              <Button
                type="button"
                basic
                color="green"
                onClick={this.onShowSelector}
              >
                Modifier
              </Button>
              {resource &&
                <Button
                  type="button"
                  basic
                  color="red"
                  onClick={this.onRemoveResource}
                >
                  Supprimer
                </Button>}
            </div>
          </Card.Content>
          <ResourceSelector
            open={selectorOpen}
            resourceType={resourceType}
            onResourceSelected={this.onResourceSelected}
            onClose={this.onHideSelector}
          />
        </Card>
      </div>
    );
  }
}

export default InputResourceCard;



// WEBPACK FOOTER //
// ./src/shared/components/InputResourceCard.js